export default __webpack_public_path__ + "static/media/gallery-image-4.a92970ae.jpg";